module.exports = __webpack_public_path__ + "static/img/ldt.50d7475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/ldt.png
// module id = E5rn
// module chunks = 0